export const DEFAULT_WAIT_MS = 2000;
export const MIN_WAIT_MS = 100;
export const MAX_WAIT_MS = 30000;

export function normalizeWaitMs(value, fallback = DEFAULT_WAIT_MS) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return fallback;
  return Math.min(MAX_WAIT_MS, Math.max(MIN_WAIT_MS, Math.round(parsed)));
}

export function createWaitToken(durationMs = DEFAULT_WAIT_MS) {
  return `wait:${normalizeWaitMs(durationMs)}`;
}

export function isWaitToken(value) {
  return /^wait:\d+$/.test(String(value || ''));
}

export function waitMsFromToken(value) {
  if (!isWaitToken(value)) return null;
  return normalizeWaitMs(String(value).slice('wait:'.length));
}

export function formatSequenceStep(value) {
  const waitMs = waitMsFromToken(value);
  if (waitMs != null) {
    const seconds = waitMs / 1000;
    return `Wait ${Number.isInteger(seconds) ? seconds : seconds.toFixed(1)}s`;
  }
  return String(value || '').replaceAll('_', ' ');
}

export function profileStepFromToken(value, stepDelayMs, checkpoint = null) {
  const waitMs = waitMsFromToken(value);
  return {
    action: waitMs == null ? value : 'wait',
    repeat: 1,
    delayAfterMs: waitMs == null ? stepDelayMs : waitMs,
    ...(checkpoint ? { checkpoint } : {}),
  };
}

export function tokensFromProfileSteps(steps) {
  const tokens = [];
  const checkpoints = [];
  (Array.isArray(steps) ? steps : []).forEach((step) => {
    const repeat = step.action === 'wait' ? 1 : Number(step.repeat) || 1;
    for (let index = 0; index < repeat; index += 1) {
      tokens.push(step.action === 'wait'
        ? createWaitToken(step.delayAfterMs ?? step.durationMs)
        : step.action);
      checkpoints.push(index === 0 ? step.checkpoint || null : null);
    }
  });
  return { checkpoints, tokens };
}

export function sequenceDelayMs(tokens, stepDelayMs) {
  return (Array.isArray(tokens) ? tokens : []).reduce((total, token) => (
    total + (waitMsFromToken(token) ?? (Number(stepDelayMs) || 0))
  ), 0);
}
